import { useQuery } from '@tanstack/react-query';
import { personalSummaryService } from '../api/personal-summary.service';
import { PERSONAL_SUMMARY_KEYS } from './queryKeys';
import type { MyTimeAnalysisParams } from '../types';

export function useMyTimeAnalysis(params?: MyTimeAnalysisParams) {
  return useQuery({
    queryKey: PERSONAL_SUMMARY_KEYS.timeAnalysis(params),
    queryFn: ({ signal }) => personalSummaryService.getMyTimeAnalysis(params, signal),
    staleTime: 120_000,
  });
}
